import { Flex, Text, Skeleton } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import ContentRightItem from "./../ContentRightItem/index";

interface ContentRightProps {
  valor: number;
  valorPago: number;
  valorLiquido: number;
  isLoading: boolean;
  encargos?: number;
  acrescimos?: number;
}

export default function ContentRight({
  valor,
  valorPago,
  valorLiquido,
  isLoading,
  encargos = 0,
  acrescimos = 0,
}: ContentRightProps) {
  return (
    <Flex flexDir="column" w="100%" pr={2} gap={1}>
      {isLoading ? (
        <Skeleton mt={3} w="100%" h="15px" rounded={6} />
      ) : (
        <Flex align="center">
          <Flex w="100%">
            <Text fontWeight="bold" fontSize={12}>
              Valor a ser pago
            </Text>
          </Flex>
          <Flex fontSize="14px" fontWeight="bold">
            {formatMoney(valorPago)}
          </Flex>
        </Flex>
      )}

      {isLoading ? (
        <Skeleton mt={3} w="100%" h="15px" rounded={6} />
      ) : valor ? (
        <ContentRightItem titulo="Valor da conta" valor={valor} />
      ) : null}

      {isLoading ? (
        <Skeleton mt={3} w="100%" h="15px" rounded={6} />
      ) : acrescimos ? (
        <ContentRightItem titulo="Acréscimos" valor={acrescimos} />
      ) : null}

      {isLoading ? (
        <Skeleton mt={3} w="100%" h="15px" rounded={6} />
      ) : encargos ? (
        <ContentRightItem titulo="Encargos" valor={encargos} />
      ) : null}

      {isLoading ? (
        <Skeleton mt={3} w="100%" h="15px" rounded={6} />
      ) : encargos ? (
        <ContentRightItem titulo="Valor líquido" valor={valorLiquido} />
      ) : null}
    </Flex>
  );
}
